function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import PropTypes from 'prop-types';
import React from 'react';
import CSSTransition from 'react-transition-group/CSSTransition';
const SLIDE_DURATION = 250;
const FADE_DURATION = 150;
const styles = require('./ToastTransition-styles.module.scss');
const propTypes = {
  children: PropTypes.node.isRequired
};

class ToastTransition extends React.Component {
  constructor(...args) {
    super(...args);

    this.onEnter = node => {
      this.height = node.offsetHeight;
      this.setZeroHeight(node);
    };

    this.onEntering = node => {
      node.style.height = `${this.height}px`;
    };
  }

  /* eslint-disable no-param-reassign */
  onExit(node) {
    node.style.height = `${node.offsetHeight || 0}px`;
  }

  onEntered(node) {
    node.style.height = '';
  }

  setZeroHeight(node) {
    node.style.height = '0px';
  }
  /* eslint-enable no-param-reassign */


  render() {
    const {
      children
    } = this.props;
    return React.createElement(CSSTransition, _extends({}, this.props, {
      classNames: styles,
      onExit: this.onExit,
      onExiting: this.setZeroHeight,
      onEnter: this.onEnter,
      onEntering: this.onEntering,
      onEntered: this.onEntered,
      timeout: {
        enter: SLIDE_DURATION + FADE_DURATION,
        exit: FADE_DURATION * 2
      }
    }), React.createElement("div", null, children));
  }

}

ToastTransition.propTypes = propTypes;
export default ToastTransition;